var svgURI = 'http://www.w3.org/2000/svg';

function createElement(name) {
  return document.createElementNS(svgURI, name);
}

exports.createElement = createElement;


//////////////////
// WEBPACK FOOTER
// ./~/_zrender@3.7.4@zrender/lib/svg/core.js
// module id = 273
// module chunks = 0